import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import AbroadBusinessIndividualBlockData from '../../../Models/Content/AbroadBusinessIndividualBlockData';
import AbroadBusinessIndividualMain from './AbroadBusinessIndividualMain';
import './abroadBusinessIndividual.scss';

export default class AbroadBusinessIndividualBlock extends EpiComponent<AbroadBusinessIndividualBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <AbroadBusinessIndividualMain iContent={this.props.data} context={this.getContext()} />;
  }
}
